export default {
    api: 'https://mp.51zhaosijiao.com/api',
    title: '身材觉醒 - 教练端',
    wechat: {
        appid: 'wx285726e8f1bf9bb3',
    },
    share: {
        url(id) {
            return `https://trainer.51zhaosijiao.com/share/${id}`;
        },
    },
};



// WEBPACK FOOTER //
// ./src/config.js